import { render, staticRenderFns } from "./AdminTweetsList.vue?vue&type=template&id=5973b26a&scoped=true&"
import script from "./AdminTweetsList.vue?vue&type=script&lang=js&"
export * from "./AdminTweetsList.vue?vue&type=script&lang=js&"
import style0 from "./AdminTweetsList.vue?vue&type=style&index=0&id=5973b26a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5973b26a",
  null
  
)

export default component.exports